/*
  Header.js (Updated)
  - Extracted the Activity Cards link to the top for easy updating.
*/
import React, { useState } from 'react';
import { Link } from 'react-router-dom'; 
import './Header.css';
import logo from '../../../assets/images/FooterLogo.png';

// --- CONFIGURATION FOR YOUR FRIEND ---
// 1. PASTE THE SECURE LINK FOR ACTIVITY CARDS HERE
// Currently pointing to the public folder placeholder.
// Your friend will change this to something like: "/api/get-activity-cards"
const ACTIVITY_CARDS_LINK = "https://drive.google.com/file/d/13V9AMnX3lukDNa5rT1oerbYObaahrbZ7/view?usp=sharing"; 

function Header({ isHeaderVisible }) {
  const [isMenuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!isMenuOpen);
  };

  // Helper to close menu
  const closeMenu = () => {
    setMenuOpen(false);
  };

  return (
    <header className={isHeaderVisible ? 'header-container visible' : 'header-container'}>
      <nav className="header-nav">
        <div className="header-logo">
          <Link to="/" onClick={closeMenu}>
            <img src={logo} alt="Dandelion Run Community Logo" />
          </Link>
        </div>

        <div 
          className={isMenuOpen ? 'header-menu-icon open' : 'header-menu-icon'}
          onClick={toggleMenu}
        >
          <span></span> 
          <span></span> 
          <span></span> 
        </div>

        <ul className={isMenuOpen ? 'header-menu-list open' : 'header-menu-list'}>
          
          {/* --- Public Pages --- */}
          <li>
            <Link to="/" onClick={closeMenu}>Home</Link>
          </li>
          <li>
            <Link to="/ContuctUs" onClick={closeMenu}>Contact Us</Link>
          </li>

          {/* --- Member Pages --- */}
          
          {/* 1. Activity Cards (Direct PDF Link) */}
          {/* We use <a> because it opens a FILE, not a page */}
          <li>
            <a 
              href={ACTIVITY_CARDS_LINK} // <-- Controlled by the constant at the top
              target="_blank" 
              rel="noopener noreferrer"
              onClick={closeMenu}
            >
              Activity Card
            </a>
          </li>

          {/* 2. Lessons (Goes to the List Page) */}
          <li>
            <Link to="/lessons" onClick={closeMenu}>Lessons</Link>
          </li>

          {/* --- Login (At the bottom) --- */}
          <li className="login-link"> 
            <Link to="/login" onClick={closeMenu}>Login</Link>
          </li>

        </ul>

      </nav>
    </header>
  );
}

export default Header;